import { render, staticRenderFns } from "./Factory-order-supplier.vue?vue&type=template&id=98841628&scoped=true&"
import script from "./Factory-order-supplier.vue?vue&type=script&lang=js&"
export * from "./Factory-order-supplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98841628",
  null
  
)

export default component.exports